export default {
  abr: {
    bandwidthDowngradeTarget: 1.3,
    bandwidthUpgradeTarget: 0.7,
    enabled: true,
    defaultBandwidthEstimate: 1000000,
    restrictions: {
      maxBandwidth: Infinity,
      maxHeight: Infinity,
      maxPixels: Infinity,
      maxWidth: Infinity,
      minBandwidth: 0,
      minHeight: 0,
      minPixels: 0,
      minWidth: 0,
    },
    switchInterval: 8,
  },
  drm: {
    servers: {
      'com.apple.fps.1_0': 'PALLYCON_LA_URL',
    },
    advanced: {
      'com.widevine.alpha': {
        distinctiveIdentifierRequired: false,
        persistentStateRequired: false,
        videoRobustness: 'SW_SECURE_CRYPTO',
        audioRobustness: 'SW_SECURE_CRYPTO',
      },
    },
    retryParameters: {
      backoffFactor: 2,
      baseDelay: 1000,
      fuzzFactor: 0.5,
      maxAttempts: 2,
    },
    delayLicenseRequestUntilPlayed: false,

  },
  restrictions: {
    maxBandwidth: Infinity,
    maxHeight: Infinity,
    maxPixels: Infinity,
    maxWidth: Infinity,
    minBandwidth: 0,
    minHeight: 0,
    minPixels: 0,
    minWidth: 0,
  },
  manifest: {
    dash: {
      // clockSyncUri: response.response.media.video_url,
      ignoreDrmInfo: false,
      xlinkFailGracefully: false,
    },
    retryParameters: {
      backoffFactor: 2,
      baseDelay: 1000,
      fuzzFactor: 0.5,
      maxAttempts: 2,
    },
  },
  streaming: {
    bufferingGoal: 30,
    bufferBehind: 12,
    rebufferingGoal: 2,
    // jumpLargeGaps: claroVideoPlayer.isLive,
    // smallGapLimit: .5,
    // startAtSegmentBoundary: true,
    // retryParameters: {
    //   maxAttempts: 3,
    //   timeout: 2e3,
    // },
  },
  preferredAudioLanguage: 'es-419',
  preferredTextLanguage: 'es-419',
};
